import Vue from "vue";
import { gameStore } from "../store/game/store";
import { Player, Card, CardCategory, ActionMode, Action } from "../store/game";
import _ from "lodash";
import { getCardFilename } from "../functions";
import { Client } from "@/client";
export default Vue.extend({
  props: {
    player: Object as () => Player
  },
  computed: {
    playersCards() {
      return gameStore.state.playersPublicCards;
    },
    playersGlasses() {
      return gameStore.state.playersGlasses;
    },
    isCurrentPlayer() {
      return gameStore.state.currentPlayerId == this.player.id;
    },
    gameEnded() {
      return gameStore.state.gameEnded && !gameStore.state.playerLeft;
    },
    myTurn() {
      return gameStore.state.currentPlayerId == gameStore.state.playerInfo.id;
    },
    clickable(): boolean {
      if (!this.myTurn) return false;
      if (gameStore.state.ui.needGlass) {
        return !this.isMe && gameStore.state.playersGlasses[this.player.id] > 0;
      }
      return gameStore.state.playersGlasses[gameStore.state.playerInfo.id] > 0;
    },
    isMe() {
      return gameStore.state.playerInfo.id == this.player.id;
    }
  },
  methods: {
    getCardFilename: (card: Card) => getCardFilename(card),
    showDlg() {
      if (!this.clickable) return;
      if (gameStore.state.ui.needGlass) {
        gameStore.commitToggleConfirmTakeGlassDlg({
          show: true,
          playerId: this.player.id
        });
        return;
      }
      if (this.isMe) {
        gameStore.commitToggleAccuseDlg(true);
        return;
      }
      gameStore.commitToggleChooseQuestionDlg({
        show: true,
        witnessId: this.player.id
      });
    }
  }
});